(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product--where-to-buy"] && !Shopify.designMode) return;
  try {
    if (!window.__wtbClickBound) {
    window.__wtbClickBound = true;

    document.addEventListener('click', function (event) {
      var link = event.target.closest('.where-to-buy-online .retailer');
      if (!link) {
        return;
      }

      var retailer = link.getAttribute('data-wtb-retailer') || '';
      var product = link.getAttribute('data-wtb-product') || '';
      var productId = link.getAttribute('data-wtb-product-id') || '';
      var productTitle = link.getAttribute('data-wtb-product-title') || '';
      var productBrand = link.getAttribute('data-wtb-product-brand') || '';
      var productCategory = link.getAttribute('data-wtb-product-category') || '';
      var market = link.getAttribute('data-wtb-market') || '';
      var position = link.getAttribute('data-wtb-position') || '';
      var url = link.href;
  
      var linkDomain = '';
      try { linkDomain = new URL(url).hostname; } catch (e) {}
  
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'where_to_buy_click', {
          retailer: retailer,
          market: market,
          destination_url: url,
          link_domain: linkDomain,
          product_id: productId || product,
          product_title: productTitle,
          product_brand: productBrand,
          product_category: productCategory,
          position: parseInt(position, 10) || undefined
        });
      } else {
        // optional: helps you debug if GA isn't loaded on that page
        console.warn('gtag not available');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
